// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/slider/slider.component.scss
// module id = 69
// module chunks = 0